import { createFileRoute } from '@tanstack/react-router';
import { BarChart3Icon } from 'lucide-react';
import type { JSX } from 'react';

import { ComingSoon } from '@/features/home/ComingSoon.js';

export const Route = createFileRoute('/reports')({
  component: ReportsPage,
});

function ReportsPage(): JSX.Element {
  return (
    <ComingSoon
      title="Reports"
      description="Status updates, risk registers, and roadmap snapshots — generated from your connected sources."
      note="Interactive reports are coming soon."
      icon={BarChart3Icon}
      tone="lavender"
    />
  );
}
